import {Inject, Injectable} from '@angular/core';
import {EntitiesChannel} from "../../../commons/angular/classes/entities-channel";
import {OrderModel} from "../../models/order.model";

@Injectable({providedIn: 'root'})
export class OrdersChannelService extends EntitiesChannel<OrderModel> {

  constructor(@Inject('firebaseService') protected firebaseService) {
    super()
  }

  getChannelName(): String {
    return "orders_changed";
  }

  getPartialChannelName(): String {
    return "orders_partial_changed";
  }

  getCreateChannelName(): String {
    return "orders_created";
  }

}
